/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import classNames from 'classnames';
import { Divider, Space } from '@coze-arch/coze-design';
import { IconMenuLogo } from '@coze-arch/bot-icons';
import { useRouteConfig } from '@coze-arch/bot-hooks';

import { type LayoutProps } from '../types';
import { SubMenu } from './sub-menu';
import { GLobalLayoutMenuItem } from './menu-item';
import { GlobalLayoutActionBtn } from './action-btn';
//rokid
import { useSpaceStore } from '@coze-foundation/space-store';
import { WorkspaceSubMenuNew } from '@coze-foundation/space-ui-base';

const siderStyle = classNames(
  'relative',
  'h-full',
  //rokid 删除圆角和边框 rounded-[14px] border-[1px] border-solid
  'coz-stroke-primary',
  'coz-bg-max',
  'flex flex-row items-stretch'
);

const mainMenuStyle = classNames(
  'px-[6px] py-[16px]',
  'flex flex-col h-full items-center',
  'min-w-[200px]',
);

export const GlobalLayoutSider: FC<Omit<LayoutProps, 'hasSider'>> = ({
  actions,
  menus,
  extras,
  onClickLogo,
  footer = null,
}) => {
  const config = useRouteConfig();
  const { subMenu: SubMenuComponent } = config;
  const hasSubNav = Boolean(SubMenuComponent);
  //rokid 使用空间信息
  const currentSpace = useSpaceStore(state => state.space);

  return (
    //rokid 删除边缘留白 pl-8px py-8px
    <div className=" h-full">
      <div className={siderStyle}>
        {/* main navigation */}
        <div
          style={{backgroundColor: 'rgb(247,247,252)',border:'1px solid rgba(82, 100, 154, 0.13)'}}
          className={classNames(
            mainMenuStyle,
            hasSubNav &&
              'border-0 border-r-[1px] border-solid coz-stroke-primary w-[200px]'
          )}
        >
          <Space spacing={4} align="center" style={{alignSelf:'flex-start'}}>
            <IconMenuLogo
              onClick={onClickLogo}
              className="cursor-pointer w-[40px] h-[40px] rounded-[8px] overflow-hidden"
            />
            <span>{currentSpace?.name || '灵珠平台'}</span>
          </Space>
          <div className="mt-[16px]">
            {actions?.map((action, index) => (
              <GlobalLayoutActionBtn {...action} key={index} />
            ))}
          </div>

          {/*
          rokid 删除分割线
          <Divider className='my-12px w-[200px]' />
           */}
          {/* rokid 删除一级菜单 工作空间和探索 */}
          {/* <Space spacing={4} vertical className='flex-1 overflow-auto'>
            {menus?.map((menu, index) => (
              <GLobalLayoutMenuItem {...menu} key={index} />
            ))}
          </Space> */}

          {/* rokid 提级显示workspace和explore的二级菜单 */}
          <WorkspaceSubMenuNew />

          <Space
            spacing={12}
            vertical
            className="mt-[12px] pb-12px fixed bottom-0"
          >
            {extras?.map((extra, index) => (
              <GlobalLayoutActionBtn {...extra} key={index} />
            ))}
            {footer}
          </Space>
        </div>
        {/* secondary navigation */}
        <SubMenu />
      </div>
    </div>
  );
};

GlobalLayoutSider.displayName = 'GlobalLayoutSider';
